const PSPlatform = require('PSPlatform');
const PSOrientationBaseController = require('./PSOrientationBaseController');

cc.Class({
    extends: PSOrientationBaseController,

    onLoad () {
        this._super();
    },

    onLandscapeMobile () {
        this.node.active = PSPlatform.isIosChrome;
    },

    onPortraitMobile () {
        this.node.active = false;
    },

    onLandscapeDesktop () {
        this.node.active = false;
    },

    onPortraitDesktop () {
        this.node.active = false;
    },
});
